import React from "react";
import SearchBar2 from "../SearchBar/SearchBar2";
import DataTable2 from "../DataTable2/DataTable2";
import PopupWithUseClickOutside from "../Popups/PopupWithUseClickOutside";
import Popup from "../Popups/Popup";
import DataTableDisplayLengthToggle from "../DataTable2/DataTableDisplayLengthToggle";
import Pagination from "../DataTable2/Pagination";
import Cell from "../DataTable2/DataTableComponents/Cell";
import UserActionsMenuList from "../UserActionsMenuList/UserActionsMenuList";

export default class LearningPlansIndexCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      meta: {},
      learningPlanName: "",
      learningPlanId: "",
      loading: false,
      initialized: false,
      isActionComplete: false,
      userLearningPlanRequest: "",
      isDeleteLearningPlanCardPopupVisible: false,
      isUserActionsMenuListVisible: false,
      sortOrder: "desc",
      sortColumn: "updated_at",
      tempQuery: "",
      query: "",
      displayOptions: [10, 25, 50, 100],
      currentPage: 1,
      pageLength: 25,
      pageNeighbours: 0,
    };

    this.onChange = this.onChange.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onClearSearch = this.onClearSearch.bind(this);
    this.onShowEditLearningPlanPage =
      this.onShowEditLearningPlanPage.bind(this);
    this.onShowDeleteLearningPlanCardPopup =
      this.onShowDeleteLearningPlanCardPopup.bind(this);
    this.onHideDeleteLearningPlanCardPopup =
      this.onHideDeleteLearningPlanCardPopup.bind(this);
    this.onShowUserActionsMenuList = this.onShowUserActionsMenuList.bind(this);
    this.onHideUserActionsMenuList = this.onHideUserActionsMenuList.bind(this);
    this.onChangeSortOrder = this.onChangeSortOrder.bind(this);
    this.onChangePageLength = this.onChangePageLength.bind(this);
    this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);
    this.onClickRouteToNewLearningPlanBuilder =
      this.onClickRouteToNewLearningPlanBuilder.bind(this);
    this.onInit = this.onInit.bind(this);
    this.onSetLearningPlanId = this.onSetLearningPlanId.bind(this);
    this.deleteLearningPlan = this.deleteLearningPlan.bind(this);
    this.onShowSuccessCardPopup = this.onShowSuccessCardPopup.bind(this);
    this.onHideSuccessCardPopup = this.onHideSuccessCardPopup.bind(this);
    this.onShowTimeoutCardPopup = this.onShowTimeoutCardPopup.bind(this);
    this.onHideTimeoutCardPopup = this.onHideTimeoutCardPopup.bind(this);
    this.onActionCompleted = this.onActionCompleted.bind(this);
  }

  render() {
    let learningPlanParams = {
      query: this.state.query,
      page: this.state.currentPage,
      results_per_page: this.state.pageLength,
      sort_column: this.state.sortColumn,
      sort_order: this.state.sortOrder,
    };

    const userActionMenuStyles = this.state.isUserActionsMenuListVisible
      ? {
          backgroundColor: "white",
          padding: "8px",
          border: "1px solid #CED4DA",
          borderRadius: "5px",
          position: "absolute",
          top: "0px",
          left: "0px",
          zIndex: "99",
          cursor: "pointer",
        }
      : {};

    return (
      <div className="LearningPlansIndexCard card">
        <div className="card-body">
          <div className="row">
            <div className="col-6">
              <h1 className="card-title">
                <div className="learning-plan-title">
                  {I18n.t("admin.learning_plans")}{" "}
                  <span>
                    {this.state.meta.total_count
                      ? `(${this.state.meta.total_count})`
                      : ""}
                  </span>
                </div>
              </h1>
            </div>
            <div className="col-6">
              <button
                type="button"
                className="btn btn-primary new-action"
                onClick={this.onClickRouteToNewLearningPlanBuilder}
              >
                {I18n.t("admin.create_learning_plan")}
              </button>
            </div>
          </div>

          {this.state.meta.total_count <= 0 ? (
            <div
              className="jumbotron mt-4 mb-0 text-center"
              style={{ backgroundColor: "#fff" }}
            >
              <div>{"No learning plans."}</div>
            </div>
          ) : null}

          <div
            style={this.state.meta.total_count <= 0 ? { display: "none" } : {}}
          >
            <div className="row filter-section">
              <div
                className={
                  this.state.tempQuery.length > 0
                    ? "col-10 col-md-10 col-lg-10"
                    : "col-12 col-md-12 col-lg-12"
                }
              >
                <SearchBar2
                  placeholder={I18n.t("search_bar.placeholder")}
                  name="tempQuery"
                  value={this.state.tempQuery}
                  onChange={this.onChange}
                  onSubmit={this.onSearch}
                />
              </div>
              <div
                className={
                  this.state.tempQuery.length < 0
                    ? ""
                    : "col-2 col-md-2 col-lg-2"
                }
              >
                {this.state.tempQuery.length > 0 ? (
                  <button
                    type="button"
                    style={{ marginLeft: "-15px" }}
                    className="btn btn-primary"
                    onClick={this.onClearSearch}
                  >
                    {I18n.t("admin.clear")}
                  </button>
                ) : (
                  ""
                )}
              </div>
            </div>
            <div className="row">
              <div
                className="jumbotron col-12 mt-4 mb-0 text-center"
                style={
                  this.state.meta.total_count > 0 || !this.state.initialized
                    ? { display: "none" }
                    : { backgroundColor: "#fff", textAlign: "center" }
                }
              >
                <div>{"No records found."}</div>
              </div>

              <div
                className="col-12"
                style={
                  this.state.meta.total_count <= 0 ? { display: "none" } : {}
                }
              >
                <DataTable2
                  onInit={this.onInit}
                  endpoint={this.buildEndpoint()}
                  params={learningPlanParams}
                  sortOrder={this.state.sortOrder}
                  sortColumn={this.state.sortColumn}
                  columns={[
                    {
                      displayName: "Name",
                      apiName: "name",
                      colNum: 1,
                      colWidth: 75,
                    },
                    {
                      displayName: "Last Updated",
                      apiName: "updated_at",
                      colNum: 3,
                      colWidth: 20,
                    },
                    {
                      displayName: "",
                      apiName: "edit",
                      colNum: 3,
                      colWidth: "",
                      isSortable: false,
                    },
                  ]}
                  rowRenderer={(d) => {
                    return (
                      <tr key={d.id}>
                        <td>
                          <Cell value={d.name} subtext={d.error_message} />
                        </td>
                        <td>
                          <Cell value={d.updated_at} type="date" />
                        </td>
                        <td>
                          <Cell
                            value={
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  e.preventDefault();
                                  this.onSetLearningPlanId(d.id);
                                  this.onShowUserActionsMenuList(d.id);
                                }}
                              >
                                <i
                                  className="fa fa-ellipsis-h"
                                  aria-hidden="true"
                                />
                                <div style={{ position: "relative" }}>
                                  <UserActionsMenuList
                                    style={userActionMenuStyles}
                                    data={[
                                      {
                                        id: 1,
                                        type: "edit",
                                        displayName: "Edit",
                                        action: (e) => {
                                          e.stopPropagation();
                                          e.preventDefault();
                                          this.onShowEditLearningPlanPage(
                                            "edit"
                                          );
                                        },
                                      },
                                      {
                                        id: 2,
                                        type: "delete",
                                        displayName: "Delete",
                                        action: (e) => {
                                          e.stopPropagation();
                                          e.preventDefault();
                                          this.onShowDeleteLearningPlanCardPopup(
                                            "delete",
                                            d.name
                                          );
                                        },
                                      },
                                    ]}
                                    isMenuListVisible={
                                      this.state
                                        .isUserActionsMenuListVisible === d.id
                                    }
                                    hideMenuList={
                                      this.onHideUserActionsMenuList
                                    }
                                  />
                                </div>
                              </div>
                            }
                          />
                        </td>
                      </tr>
                    );
                  }}
                  onChange={this.onChange}
                  onChangeSortOrder={this.onChangeSortOrder}
                  isActionComplete={this.state.isActionComplete}
                />
              </div>
            </div>
          </div>
          <div className="row table-footer">
            <div className="col-12 col-sm-6">
              <Pagination
                totalRecords={true ? 0 : 0}
                pageLength={this.state.pageLength}
                currentPage={this.state.currentPage}
                pageNeighbours={this.state.pageNeighbours}
                onChangeCurrentPage={this.onChangeCurrentPage}
              />
            </div>
            <div className="col-12 col-sm-6">
              <DataTableDisplayLengthToggle
                totalRecords={true ? 0 : 0}
                displayOptions={this.state.displayOptions}
                pageLength={this.state.pageLength}
                onChangePageLength={this.onChangePageLength}
              />
            </div>
            <PopupWithUseClickOutside
              isPopupVisible={this.state.isSuccessCardPopupVisible}
              onHidePopup={this.onHideSuccessCardPopup}
            >
              <Popup
                title={
                  <h1 className="card-title" style={{ color: "green" }}>
                    {I18n.t("success_card_title")}
                  </h1>
                }
                body={
                  this.state.userLearningPlanRequest === "add"
                    ? I18n.t("admin.learning_plan.success_new_learning_plan")
                    : this.state.userLearningPlanRequest === "edit"
                    ? I18n.t("admin.learning_plan.success_update_learning_plan")
                    : this.state.userLearningPlanRequest === "delete"
                    ? I18n.t("admin.learning_plan.success_delete_learning_plan")
                    : null
                }
                onHidePopup={this.onHideSuccessCardPopup}
              />
            </PopupWithUseClickOutside>
            <PopupWithUseClickOutside
              isPopupVisible={this.state.isTimeoutCardPopupVisible}
              onHidePopup={this.onHideTimeoutCardPopup}
            >
              <Popup
                title={
                  <h1 className="card-title" style={{ color: "red" }}>
                    {I18n.t("timeout_card_title")}
                  </h1>
                }
                body={I18n.t("timeout_card_body")}
                onHidePopup={this.onHideTimeoutCardPopup}
              />
            </PopupWithUseClickOutside>
            <PopupWithUseClickOutside
              isPopupVisible={this.state.isDeleteLearningPlanCardPopupVisible}
              onHidePopup={this.onHideDeleteLearningPlanCardPopup}
            >
              <Popup
                title={
                  <h1 className="card-title">
                    {I18n.t("admin.learning_plan.delete_learning_plan_title")}
                  </h1>
                }
                body={
                  <div>
                    {this.state.learningPlanName
                      ? I18n.t(
                          "admin.learning_plan.delete_learning_plan_body",
                          {
                            learningPlanName: this.state.learningPlanName,
                          }
                        )
                      : I18n.t("admin.learning_plan.delete_learning_plan_body")}
                    <div style={{ float: "right" }} className="mt-4">
                      <button
                        className="btn btn-secondary mx-2"
                        onClick={this.onHideDeleteLearningPlanCardPopup}
                      >
                        No, cancel
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={this.deleteLearningPlan}
                      >
                        Yes, delete
                      </button>
                    </div>
                  </div>
                }
                onHidePopup={this.onHideDeleteLearningPlanCardPopup}
              />
            </PopupWithUseClickOutside>
          </div>
        </div>
        {this.state.loading ? (
          <div className="loadingOverlay">
            <div className="spinner" />
            {this.state.loadingMessage ? (
              <div className="loadingMessage">{this.state.loadingMessage}</div>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }

  buildEndpoint() {
    return `${this.props.learning_plans_list_endpoint}`;
  }

  onClickRouteToNewLearningPlanBuilder() {
    this.setState({
      loading: true,
      loadingMessage: I18n.t("admin.creating_learning_plan"),
      isUserActionsMenuListVisible: false,
    });
    window.location.href = `/admin/${this.props.public_id}/learning-plan/new`;
  }

  onChange(event) {
    const { name, value } = event.target;
    const { state } = this;
    state[name] = value;
    this.setState(state);
  }

  onSetLearningPlanId(learningPlanId) {
    this.setState({ learningPlanId: learningPlanId });
  }

  onShowEditLearningPlanPage() {
    this.setState({
      loading: true,
      loadingMessage: I18n.t("admin.editing_learning_plan"),
      isUserActionsMenuListVisible: false,
    });
    window.location.href = `/admin/${this.props.public_id}/learning-plan/edit/${this.state.learningPlanId}`;
  }

  onShowDeleteLearningPlanCardPopup(userLearningPlanRequest, learningPlanName) {
    this.setState({
      userLearningPlanRequest: userLearningPlanRequest,
      learningPlanName: learningPlanName,
      isDeleteLearningPlanCardPopupVisible: true,
      isUserActionsMenuListVisible: false,
    });
  }

  onHideDeleteLearningPlanCardPopup() {
    this.setState({
      isDeleteLearningPlanCardPopupVisible: false,
    });
  }

  onShowUserActionsMenuList = (id) => {
    this.setState({
      isUserActionsMenuListVisible: id,
    });
  };

  onHideUserActionsMenuList = () => {
    this.setState({ isUserActionsMenuListVisible: false });
  };

  deleteLearningPlan() {
    $.ajax({
      type: "DELETE",
      url: this.props.delete_learning_plan_endpoint,
      data: {
        id: this.state.learningPlanId,
      },
    }).done((data) => {
      if (data.success == true) {
        this.setState({
          loading: false,
        });
        this.onHideDeleteLearningPlanCardPopup();
        this.onShowSuccessCardPopup("delete");
        this.onActionCompleted();
      } else if (data.status == "session_expired") {
        this.onHideDeleteLearningPlanCardPopup();
        this.onShowTimeoutCardPopup();
      } else {
        this.setState({
          loading: false,
        });
      }
    });
  }

  onShowSuccessCardPopup = () => {
    this.setState({
      isSuccessCardPopupVisible: true,
      sortOrder: "desc",
      sortColumn: "updated_at",
      tempQuery: "",
      query: "",
      currentPage: 1,
    });
  };

  onHideSuccessCardPopup = () => {
    this.setState({ isSuccessCardPopupVisible: false });
  };

  onActionCompleted = () => {
    this.setState({ isActionComplete: true });
    this.setState({ isActionComplete: false }); // Reset state for next action
  };

  onShowTimeoutCardPopup = () => {
    this.setState({ isTimeoutCardPopupVisible: true });
  };

  onHideTimeoutCardPopup = () => {
    this.setState({ isTimeoutCardPopupVisible: false });
  };

  onSearch(event) {
    event.preventDefault();
    this.setState({ query: this.state.tempQuery });
  }

  onClearSearch(event) {
    event.preventDefault();
    this.setState({ tempQuery: "", query: "", currentPage: 1 });
  }

  onChangeSortOrder(sortColumn, sortOrder) {
    if (sortOrder === "" || sortOrder === "desc") {
      this.setState({
        sortColumn: sortColumn,
        sortOrder: "asc",
        currentPage: 0,
      });
    } else if (sortOrder === "asc") {
      this.setState({
        sortColumn: sortColumn,
        sortOrder: "desc",
        currentPage: 0,
      });
    }
  }

  onChangeCurrentPage(currentPage) {
    this.setState({ currentPage: currentPage });
  }

  onChangePageLength(pageLength) {
    this.setState({ pageLength: pageLength, currentPage: 1 });
  }

  onInit() {
    this.setState({ initialized: true });
  }
}
